/* Shto jump: a link with data-shto-jump and href="#<id>" scrolls to that element on the page.
   Blushe's theme (assets/global.js) catches every a[href^="#"] click, writes the hash into the address bar and jumps there
   again on every load with a hash, so a reloaded or shared page would open at the buy box. This runs first (capture phase)
   and stops the click, so the address never changes. Smooth unless the visitor asks for reduced motion. */
(function () {
  if (window.ShtoJump) return;
  window.ShtoJump = true;
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a[data-shto-jump]');
    if (!link) return;
    var hash = link.getAttribute('href') || '';
    if (hash.charAt(0) !== '#' || hash.length < 2) return;
    var target = document.getElementById(decodeURIComponent(hash.slice(1)));
    if (!target) return;
    event.preventDefault();
    event.stopPropagation();
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }, true);
})();
